/**
 * Single switch for whether sign-in (and everything that needs the backend) is offered.
 * Defaults to OFF (AWS exit, 2026-11): only REACT_APP_LOGIN_ENABLED=true turns login on. While off,
 * sign-in and signed-in routes redirect to "/", the navbar Login/Dashboard button is disabled with a
 * maintenance tooltip, stored sessions are ignored, RUM is skipped, and a maintenance banner shows.
 * Any environment with a working backend (local dev, staging, prod after Azure) must set it to "true".
 */

export const LOGIN_ENABLED: boolean = process.env.REACT_APP_LOGIN_ENABLED === "true";

// Routes that only work with a running backend: sign-in flows, signed-in pages, and canvases
// (public demo canvases load from the backend too). Matched as exact paths or path prefixes.
const BACKEND_ONLY_PATH_PREFIXES: readonly string[] = [
  "/login",
  "/signup",
  "/confirm-signup",
  "/forgot-password",
  "/reset-password",
  "/change-password",
  "/adminregister",
  "/redriveindexing",
  "/dashboard",
  "/canvas",
  "/sandbox",
  "/installer",
];

/** True when login is disabled and `pathname` needs the backend, so the app should send the user to "/". */
export const shouldRedirectHomeWhileLoginDisabled = (pathname: string): boolean => {
  if (LOGIN_ENABLED) {
    return false;
  }
  return BACKEND_ONLY_PATH_PREFIXES.some(
    (prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`),
  );
};
